/**
 * MODAL-INPUT
 * Dialog for editing input
 */
import { createPortal } from "react-dom"
import Button from "./button"
import { useState } from "react"
import { SlideInTop } from "@/utils/animations.utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"

interface Props {
  title?: string
  value: string
  placeholder?: string
  rows?: number
  type?: string
  onClose: () => void
  onNext: (value: string) => void
}

function ModalInput(props: Props) {
  const [value, setValue] = useState(props.value)
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)
  const isPassword = props.type === "password"
  const inputType = isPassword ? (isPasswordVisible ? "text" : "password") : props.type

  return createPortal(
    <SlideInTop className="bg-white h-[100dvh] w-full flex fixed top-0 left-0 z-[99999]">
      <div className="flex-1 mt-40 mx-40">
        {props.title && <div className="text-2xl mb-20 grey-t">{props.title}</div>}
        <div className="flex items-start">
          <div className="relative flex flex-1">
            {props.rows ? (
              <textarea
                className="text-area flex-1 w-fit resize-none"
                placeholder={props.placeholder}
                rows={Math.max(3, props.rows)}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                autoFocus
              />
            ) : (
              <input
                className="text-area flex-1 w-fit"
                placeholder={props.placeholder}
                type={inputType}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                autoFocus
              />
            )}
            {isPassword && (
              <button
                type="button"
                className="absolute right-[14px] top-1/2 -translate-y-1/2 grey-t _hover"
                onClick={() => setIsPasswordVisible((value) => !value)}>
                <FontAwesomeIcon icon={isPasswordVisible ? faEyeSlash : faEye} />
              </button>
            )}
          </div>
          <div className="w-40" />
          <div className="flex shrink-0">
            <Button isWithBorder onClick={() => props.onClose()}>
              Retour
            </Button>
            <Button className="primary" isWithBorder onClick={() => props.onNext(value)}>
              Valider
            </Button>
          </div>
        </div>
      </div>
    </SlideInTop>,
    document.body
  )
}

export default ModalInput
